export enum ExternalFieldInputMode {
    Simple = 0,
    Autocomplete = 1,
    ExternalList = 2
}